import { slideFileFromSlide, tileExtensionFromSlideFile } from "../showTile/tileUrl";

/*
  Tile-based cover for slide cards — same rule as the mobile app
  (`microlab/src/utils/tileUrl.ts` → `slideThumbnailUrlFromSlide`):

    `{Files[0].url}/3/3/3.{ext}`

  That tile is a mid-pyramid crop (center-ish of many slides) with a
  little zoom vs the letterboxed `0/0/0` overview. Fallbacks cover
  shallow pyramids that never generate level 3.
*/

const TILE_PATHS = ["3/3/3", "2/1/1", "2/0/0", "1/0/0", "0/0/0"];

function probe(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

/** Absolute URLs of the slide's own files (not a separately attached cover). */
export function slideOwnFileUrls(slide) {
  const files = slide?.Files ?? slide?.files ?? [];
  return new Set(
    (Array.isArray(files) ? files : []).map((f) => f?.url || f?.path).filter(Boolean)
  );
}

export async function resolveSlideTileCover(slide) {
  const file = slideFileFromSlide(slide);
  if (!file?.url) return null;
  const base = String(file.url).replace(/\/+$/, "");
  const exts = [...new Set([tileExtensionFromSlideFile(file), "jpg", "png", "webp"])];
  for (const ext of exts) {
    for (const path of TILE_PATHS) {
      const src = `${base}/${path}.${ext}`;
      if (await probe(src)) {
        return {
          kind: "image",
          src,
          // App-style mid zoom; overview (0/0/0) needs a stronger crop.
          zoomed: path !== "0/0/0",
        };
      }
    }
  }
  return null;
}
